import { CategorieInput, CategorieItem, CategoriesPaginated } from 'types/CategoriesTypes';
import useHttp from '../helpers/HttpMethods';
import { ServiceCatalogById, ServiceCatalogTreeView, ServiceCatalogTreeViewByServiceCatalog } from 'types/ServiceCatalogTypes';

class CategoriesService {
/**
   * Busca as categorias paginadas.
   * @param {string} filter - filtros em string.
   * @returns {Promise<Response | CategoriesPaginated>}
   */
static async list(filter: string): Promise<Response | CategoriesPaginated> {
  return await useHttp().get(`/categories?${filter}`);
}

/**
   * Busca os catálogos de serviço por catálogo de serviço.
   * @param {number} serviceCatalogId - id do catálogo de serviço.
   * @param {string} filter - filtro em formato de string.
   * @returns {Promise<Response | CategoriesPaginated>}
   */
static async listByServiceCatalog(serviceCatalogId: number, filter: string): Promise<Response | CategoriesPaginated> {
  return await useHttp().get(`/categories/by-service-catalog/${serviceCatalogId}?${filter}`);
}

/**
   * Cria uma nova categoria de catalogo de serviço.
   * @param {CategorieInput} body - objeto necessário para criar uma categoria nova: 
   * nome e um objeto catalogo de serviço: id.
   * @returns {Promise<CategorieItem>}
   */
static async create(body: CategorieInput): Promise<CategorieItem> {
  return await useHttp().post(body, '/categories');
}

/**
   * Edita uma categoria de catálogo de serviço.
   * @param {number} id - ID da categoria.
   * @param {CategorieInput} body - tipo do objeto enviado.
   * @returns {Promise<Response | CategorieItem>}
   */
static async edit(id: number, body: CategorieInput): Promise<Response | CategorieItem> {
  return await useHttp().put(body, `/categories/${id}`);
}
}

export default CategoriesService
